// extracted by css-extract-rspack-plugin
export default {"dialog":"diBi0EpWrQ0ZlGEE","header":"aSrBg7l8QgBoU4BK","afterSearch":"pZAzsyDXLsPUukeu","search":"hE4uyxrQCdg_cJWp","list":"akh27ewilaQVhP_z"};